// extracted by mini-css-extract-plugin
export default {"root":"SignInLayout_root-hpo","header":"SignInLayout_header-CGU"};